import React from 'react';
import { useYoutubeApi } from '../context/YoutubeApiContext';
import { useQuery } from '@tanstack/react-query';
import VideoCard from './VideoCard';
import './ChannelPlaylist.css';

export default function ChannelPlaylist({ channelId }) {
    const { youtube } = useYoutubeApi();
    const { data: videos } = useQuery({
        queryKey: ["playlist", channelId],
        queryFn: () => {
            return youtube.searchByChannelId(channelId);
        },
    });
    return (
        <div>
            {videos && (
                <ul className='ul'>
                    {videos.map((video) => (
                        <VideoCard key={video.id} video={video} />
                    ))}
                </ul>
            )}
        </div>
    );
}

